module.exports = __webpack_public_path__ + "static/media/kia-go-drive.77ec067e.png";